// extracted by mini-css-extract-plugin
module.exports = {"container":"L5cPDlW92BANBZQFT9rHug==","sidePanel":"RECjx8CZZDhYCbZ51Igbdg=="};